import { fetchAuthSession, signOut } from "aws-amplify/auth";
import store from "@/store";

export const isAuthSessionError = (error) => {
  const message = error?.message || error?.errors?.[0]?.message || "";
  const name = error?.name || "";
  return (
    message.includes("NoValidAuthTokens") ||
    message.includes("No federated jwt") ||
    message.includes("UserUnAuthenticatedException") ||
    message.includes("NotAuthorizedException") ||
    message.includes("Token expired") ||
    name === "UserUnAuthenticatedException" ||
    name === "NotAuthorizedException"
  );
};

/**
 * Ensure Cognito tokens are present. Optionally force a refresh so long-running
 * actions (like report generation) do not use a stale access token.
 */
export async function ensureAuthSession({ forceRefresh = false } = {}) {
  try {
    const session = await fetchAuthSession({ forceRefresh });
    const accessToken = session?.tokens?.accessToken;
    const idToken = session?.tokens?.idToken;
    return Boolean(accessToken || idToken);
  } catch (error) {
    console.error("ensureAuthSession failed:", error);
    return false;
  }
}

export async function clearAuthAndRedirect(router) {
  try {
    await signOut();
  } catch (error) {
    console.error("Sign out failed:", error);
  } finally {
    try {
      store.dispatch("setCurrentUser", null);
    } catch (_) {
      /* store may be unavailable during teardown */
    }
    localStorage.removeItem("lastActiveTime");
    if (router?.currentRoute?.value?.path !== "/") {
      router.push("/");
    }
  }
}
